/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

export interface IAddressSignUpErrorProps {
    id?: string;
    /** danger, info, success */
    variant?: 'danger' | 'info' | 'success';
    message?: string;
}

export const SignUpError: React.FC<IAddressSignUpErrorProps> = ({ id, variant = 'danger', message }) => {
    // Only render if message is present
    if (!message) {
        return null;
    }
    const baseBlock = 'msc-address-form__item';
    const isAlert = variant === 'danger';
    const role = isAlert ? 'alert' : 'status';
    const ariaLive = isAlert ? 'assertive' : 'polite';

    return (
        <div id={id} className={baseBlock} role={role} aria-live={ariaLive} aria-label={message}>
            <p className={`${baseBlock}-item-${variant}-text`}>{message}</p>
        </div>
    );
};

export default SignUpError;
